import styled from 'styled-components';
import { FlexContainer } from '@taxdown/piccolo-web';
import { pxToRem } from 'Styles/utils/utils';
import { DESKTOP_SMALL_WITDH, MOBILE_WIDTH, TABLET_WIDTH } from 'Styles/variables/sizes';

export const ButtonsContainer = styled(FlexContainer)`
  display: flex;
  justify-content: center;
  border-top: 1px solid ${({ theme: { colors } }) => colors.blue_5};
  padding: ${pxToRem(20)};
  margin: 0 ${pxToRem(-30)};
  > div {
    display: flex;
    justify-content: ${({ justify }) => justify ?? 'space-around'};
  }
  @media screen and (max-width: ${DESKTOP_SMALL_WITDH}) {
    button {
      min-width: ${pxToRem(200)};
    }
  }
  @media screen and (max-width: ${TABLET_WIDTH}) {
    button {
      min-width: ${pxToRem(150)};
    }
  }
  @media screen and (max-width: ${MOBILE_WIDTH}) {
    margin: 0;
    padding-right: 0;
    padding-left: 0;
    border-top: 0;
    button {
      min-width: ${pxToRem(150)};
    }
  }
`;
